module.exports = __webpack_public_path__ + "img/10.84e78f0d.jpg";